import {action} from "mobx";
import {GridRow} from "core/grid/domain/grid";

export interface WithGridLocations {
  $dirty: boolean;
  gridLocations: string[];
}


export const getSelectGridLocation = (objekt: WithGridLocations, gridLocation: string) => {
  return objekt.gridLocations.includes(gridLocation);
};

export const setSelectGridLocation = action("setSelectGridLocation-action", (objekt: WithGridLocations, gridLocation: string, item: GridRow, checked: boolean) => {
  console.log('setSelectGridLocation %s .. %s...%s', gridLocation, item, checked);
  let ti = objekt.gridLocations.indexOf(gridLocation);
  if (checked) {
    if (ti === -1) objekt.gridLocations.push(gridLocation);
  } else {
    if (ti >= 0) objekt.gridLocations.splice(ti, 1);
  }
  objekt.$dirty = true;
});



// WEBPACK FOOTER //
// ./src/core/grid/gridSelectionSupport.ts